import logo from "./logo.svg";
import "./App.css";
import InitialScreen from "./pages/QuizScreen";

function App() {
    return (
        <div className="App">
            <InitialScreen />
        </div>
    );
}

export default App;
